import { SystemField } from "./system-field";

export class KitAssemblyDetail extends SystemField{ 
     kit_assembly_id?:string;
     product_id?:string;
     trans_uom_id?:string;
     base_uom_id?:string;
     qty?:number;
     location_id?:string;
     unit_cost?:number;
     variant_qty?:number;
     product_type?:string;

}
